module.exports = __webpack_public_path__ + "img/selected_icon.04e0853.png";